import { render, staticRenderFns } from "./NotificationPropertiesCard.vue?vue&type=template&id=6f9824a3&scoped=true"
import script from "./NotificationPropertiesCard.vue?vue&type=script&lang=js"
export * from "./NotificationPropertiesCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationPropertiesCard.vue?vue&type=style&index=0&id=6f9824a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9824a3",
  null
  
)

export default component.exports